import React, { Fragment } from "react";
import { get } from "lodash";
import styled from "styled-components";
import InputContainer from "./InputContainer";
import Checkbox, { NativeCheckbox } from "./Checkbox";
import Select from "./Select";
import Label from "./Label";
import * as colors from "../../settings/colors";

const OnScreenControl = styled.div`
  display: block;

  @media only print {
    display: none;
  }
`;

const PrintedValue = styled.div`
  display: none;

  @media only print {
    display: block;
  }
`;

const ValueContainer = styled.div`
  color: ${colors.TEXT};
  font-family: inherit;
  font-size: 14px;
  line-height: 18px;
  box-sizing: border-box;
  width: 100%;
  padding: 8px 9px;
  border: 1px solid ${colors.DIVIDER};
  border-radius: 3px;
  box-shadow: inset 0 1px 2px ${colors.FORM_INPUT_INSET_SHADOW};
`;

const TransmittalField = ({ templateField, ...otherProps }) => {
  switch (templateField.field_type) {
    case "text_field":
      return (
        <Fragment>
          <OnScreenControl>
            <InputContainer {...otherProps} />
          </OnScreenControl>
          <PrintedValue>
            <Label htmlFor={otherProps.name} size={otherProps.size}>
              {otherProps.labelText}
            </Label>
            <ValueContainer>
              {get(otherProps, "input.value") || otherProps.value}
            </ValueContainer>
          </PrintedValue>
        </Fragment>
      );
    case "checkbox":
      if (otherProps.input) return <Checkbox {...otherProps} />;
      return <NativeCheckbox {...otherProps} />;
    case "dropdown":
      return (
        <InputContainer
          {...otherProps}
          fieldComponent={Select}
          allowCreate={true}
          options={templateField.choices
            .filter(choice => choice !== "")
            .map(choice => ({
              value: choice,
              label: choice
            }))}
        />
      );
    case "section":
      return <b>{templateField.name}</b>;
    default:
      return <InputContainer {...otherProps} />;
  }
};

export default TransmittalField;



// WEBPACK FOOTER //
// ./src/components/forms/TransmittalField.js